import { BaseMapper } from '../shared/base.mapper';
import { Operator } from '../../types/operator/operator.type';
import { Injectable } from "@angular/core";

@Injectable()
export class OperatorMapper extends BaseMapper<Operator> {

}
